var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    "data-e2e": "",
    height: 24,
    viewBox: "0 0 48 48",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6C20.134 6 17 9.13401 17 13V17H31V13C31 9.13401 27.866 6 24 6ZM35 17V13C35 6.92487 30.0751 2 24 2C17.9249 2 13 6.92487 13 13V17H12C8.68629 17 6 19.6863 6 23V39C6 42.3137 8.68629 45 12 45H36C39.3137 45 42 42.3137 42 39V23C42 19.6863 39.3137 17 36 17H35ZM12 21C10.8954 21 10 21.8954 10 23V39C10 40.1046 10.8954 41 12 41H36C37.1046 41 38 40.1046 38 39V23C38 21.8954 37.1046 21 36 21H12ZM26 32.4649C27.1956 31.7733 28 30.4806 28 29C28 26.7909 26.2091 25 24 25C21.7909 25 20 26.7909 20 29C20 30.4806 20.8044 31.7733 22 32.4649V37C22 37.5523 22.4477 38 23 38H25C25.5523 38 26 37.5523 26 37V32.4649Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.5e5a5bd486a2d95064c22e7cb8779066.svg";
export { ForwardRef as ReactComponent };